(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(root) {
    const scope = root || document;
    const section = scope.querySelector('[data-bamboo-benefits-strip]');
    if (!section || section.dataset.bambooBenefitsInit === 'true') return;

    section.dataset.bambooBenefitsInit = 'true';
    const items = section.querySelectorAll('[data-bamboo-reveal]');
    if (!items.length) return;

    if (REDUCED_MOTION || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -5% 0px' }
    );

    items.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSection());
  } else {
    initSection();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
  });
})();
